<template>
  <!-- <div class="classification" v-show="componentContent.categoryShow || canShow"> -->
  <div class="classification" v-show="componentContent.categoryShow || canShow">
    <ul>
      <li :style="liStyle" v-for="(item, index) in componentContent.category" :key="index">
        <div @mouseleave="showClassify = false"
            @mouseenter="iscategoryName(item.categoryName)">
          <div
            class="item"
            
          >
            <!-- <span :class="getIcon(item.categoryName)"></span> -->
            <!-- <p :style="`background-image:url(../../../assets/images/${getIcon(item.categoryName)}.png);background-size:cover;`"></p> -->
            <!-- <img v-if="!item.categoryName.includes('物流')" :src="`${require(`../../../../assets/images/${getIcon(item.categoryName)}.png`)}`" alt="" /> -->
            <img v-if="getIconUrl(item.id)" :src="getIconUrl(item.id)" alt="" />
            <span
              style="cursor: pointer"
              @click.stop="
                jumpCategory({ ...item, rootName: item.categoryName })
              "
              >{{ item.categoryName }}</span
            >
            <!-- <i class="icon el-icon-arrow-right"></i> -->
          </div>
          <!-- <div class="item-detail">
            <template v-for="(subItem, index) in item.childs">
              <span
                style="cursor: pointer"
                :key="subItem.id"
                v-if="index < 3"
                @click.stop="
                  jumpCategory({ ...subItem, rootName: item.categoryName })
                "
                >{{ subItem.categoryName }}</span
              >
            </template>
          </div> -->
        </div>

        <div
          style="display: none"
          class="hoverBox"
          :class="{ canScroll: item.childs.length > 6 }"
        >
          <div class="dl" v-for="subItem in item.childs" :key="subItem.id">
            <div
              class="dt"
              style="cursor: pointer"
              @click.stop="
                jumpCategory({ ...subItem, rootName: item.categoryName })
              "
            >
              {{ subItem.categoryName }}
            </div>
            <div class="dd">
              <a
                class="a-link"
                v-for="threeItem in subItem.childs"
                :key="threeItem.id"
                @click.stop="
                  jumpCategory({ ...threeItem, rootName: item.categoryName })
                "
              >
                {{ threeItem.categoryName }}
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
    
    <div
      v-if="showClassify && $route.name == 'index'"
      :class="showClassify && $route.name == 'index' ? 'showClassify' : 'showClassify other'"
      @mouseleave="showClassify = false"
      @mouseenter="showClassify = true"
    > 
      
      <div  v-for="(item, index) in componentContent.category" :key="index">
        <div
          v-for="(subItem, index) in item.childs"
          :key="index"
          v-if="flag == item.categoryName"
          class="category"
        >
          <div

          class="twocategory"
            style="cursor: pointer"
            :key="subItem.id"
            @click.stop="
              jumpCategory({ ...subItem, rootName: item.categoryName })
            "
            >{{ subItem.categoryName }}</div
          >
          <div class="threecategory">
            <span style="cursor: pointer" v-for="(Item2, index) in subItem.childs" :key="index" @click.stop="
                  jumpCategory({ ...Item2, rootName: item.categoryName })
                ">
            {{ Item2.categoryName }}</span
          >
          </div>
          
        </div>
      </div>
    </div>
     <div
      v-else-if=" $route.name != 'index'"
      :class="showClassify && $route.name == 'index' ? 'showClassify' : 'showClassify other'"
      @mouseleave="showClassify = false"
      @mouseenter="showClassify = true"
    > 
      
      <div  v-for="(item, index) in componentContent.category" :key="index">
        <div
          v-for="(subItem, index) in item.childs"
          :key="index"
          v-if="flag == item.categoryName"
          class="category"
        >
          <div

          class="twocategory"
            style="cursor: pointer"
            :key="subItem.id"
            @click.stop="
              jumpCategory({ ...subItem, rootName: item.categoryName })
            "
            >{{ subItem.categoryName }}</div
          >
          <div class="threecategory">
            <span style="cursor: pointer" v-for="(Item2, index) in subItem.childs" :key="index" @click.stop="
                  jumpCategory({ ...Item2, rootName: item.categoryName })
                ">
            {{ Item2.categoryName }}</span
          >
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { funMixin } from "../../config/mixin";
import api from "@/api";
import { mapGetters } from "vuex";
export default {
  name: "cereClassification",
  mixins: [funMixin],
  props: {
    canShow: {
      default: false,
    },
  },
  data() {
    return {
      showClassify: false,
      flag: "大宗粮油",
      icons: {
        校: "icon-Intercollegiate-business-circle",
        物业: "icon-Intellectual-property",
        禽: "icon-Livestock-industry",
        矿: "icon-Mineral-resources",
        粮: "icon-Bulk-grain-and-oil",
        工地: "icon-Wisdom-site",
        政府: "icon-The-government-acquisition",
        农: "icon-Agricultural-special-products",
        物流: "icon-Warehousing-logistics",
      },
      liStyle: '',
      
    };
  },
  computed: {
    ...mapGetters(["classify"]),
  },
  mounted() {
    this.getClassifyInfo()
    console.log(this.componentContent)
    let LiNum = this.componentContent.category.length;
    this.liStyle = `height:${620/10}px`;
    console.log(LiNum);
  },
  methods: {

    iscategoryName(item) {
      this.showClassify = true;
      this.flag = item;
      // console.log(item);
    },
    getIcon(str) {
      for (let key in this.icons) {
        if (str.includes(key)) {
          return this.icons[key];
        }
      }
      return "";
    },
    getIconUrl(id) {
      //用id匹配
      if (this.classify) {
        for (let i in this.classify) {
          if (this.classify[i].id == id) {
            return this.classify[i].classifyImage;
          }
        }
      }
      return null;
    },
    getClassifyInfo() {
      let self = this;
      let _url = api.getClassify + ``;
      // if (self.activeName !== "all") {
      //   _url += `&classifyId=${self.activeName}`;
      // }
      let params = {
        url: _url,
        method: "GET",
        data: {},
      };
      this.sendReq(params, (res) => {
        if (res.code === "200") {
          this.componentContent.category = res.data;
          // self.total = res.data.page.total;
          // console.log(self.categoryData);

          // this.$store.state.componentContent.category = self.categoryData
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
  },
  props: {
    componentContent: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.showClassify {
  z-index: 999;
  position: absolute;

  top: 0;
  left: 250px;
  width: 1050px;
  height: 620px;
  background-color: #ffffff;
  border: 1px solid #f77b0b;
  padding: 30px;
  &.other{
    
  }
  .category{
    display: flex;
    justify-content: left !important;
    margin:0 0 20px 0;
    .twocategory{
      min-width: 80px;
      margin-right: 40px;
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      &:hover{
        color: #f77b0b;
      }

    }
    .threecategory{
      width: 100%;
      font-size: 16px;
      color: #606266; 
      padding-bottom:20px;
      border-bottom: 1px dashed #E5E5E5;;
      text-align: left !important;
      span{
        margin-right: 30px;
        &:hover{
        color: #f77b0b;
      }
      }
    }
  }
}
.classification {
  position: relative;
  // width: 17%;
  box-shadow: 2px 2px 10px #cccccc59;
  width: 250px;
  height: 620px;
  padding: 0;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #000;
  position: absolute;
  z-index: 20;
  left: 0;
  top: 0;
  // padding-top: 13px;
  padding-bottom: 13px;
  ul {
    li {
      // height: 50px;
      .item {
        cursor: pointer;
        padding: 14px 20px 8px 25px;
        height: 100%;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        p {
          display: inline-block;
          width: 26px;
          height: 27px;
        }
        img {
          display: inline-block;
          width: 32px;
          height: 33px;
          margin-right: 12px;
        }
        span {
          display: inline-block;
          font-size: 18px;
          margin-right: 12px;
        }
        span:before {
          font-size: 18px;
          color: #333;
        }
      }
      .item-detail {
        cursor: pointer;
        margin: 0 20px 0 25px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        font-size: 14px;
        color: #606266;
        border-bottom: 1px dashed #a7a9ae;
        span {
          // margin-right: 42px;
          padding: 0 18px;
          border-left: 1px solid #a9adb4;
          margin-bottom: 30px;
          height: 16px;
          line-height: 16px;
        }
        span:first-child {
          padding-left: 0;
          border-left: none;
        }
        span:hover {
          color: #ff7b0b;
        }
      }
      // .icon{
      // }
      .hoverBox {
        position: absolute;
        width: 998px;
        padding: 6px 25px;
        height: 100%;
        left: 100%;
        top: 0;
        z-index: 3;
        display: none;
        background-color: #fff;
        color: #333;
        box-shadow: -3px 9px 15px 0px rgba(0, 0, 0, 0.5);
        // border: 2px solid $mainColor;

        .dl {
          margin-bottom: 5px;
          display: flex;

          .dt {
            width: 12%;
            height: 50px;
            display: flex;
            padding-top: 22px;
            // align-items: center;
            align-items: flex-start;
            font-size: 16px;
            font-weight: bold;
            color: #000000;
          }
          .dt:hover {
            color: #ff7b0b;
          }
          .dd {
            display: flex;
            width: 88%;
            margin-left: 10px;
            flex-wrap: wrap;
            border-bottom: 1px dotted #e5e5e5;
            padding-top: 23px;
            a {
              display: flex;
              align-items: flex-start;
              height: 41px;
              font-size: 14px;
              // align-items: center;

              margin-right: 40px;
              &:hover {
                color: $mainColor;
              }
            }
          }
        }
      }
      .canScroll {
        overflow-y: scroll;
      }
      &:hover {
        color: $mainColor;
        span:before {
          color: $mainColor;
        }
        .hoverBox {
          display: block;
          margin-top: 10px;
          width: 998px;
          height: 634px;
          border-radius: 8px;
          border: 1px solid #f77b0b;
        }
      }
    }
    li:last-child {
      .item-detail {
        border-bottom: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc/classification.vue